import { ExtraOptions } from "../api/useRecords";
import { findField } from "./findField";

type Filter = {
	[key: string]: any;
};

type FilterObject = {
	_and?: Filter[];
	_or?: Filter[];
};

export const createFilters = (options: ExtraOptions | undefined) => {
	if (!options?.filter) return;
	const { filter } = options as { filter: FilterObject };

	let filterKey: keyof FilterObject | null = filter.hasOwnProperty("_and")
		? "_and"
		: filter.hasOwnProperty("_or")
		? "_or"
		: null;

	let customFilters: Filter | Filter[] = [];
	let normalFilters: Filter | Filter[] = [];

	if (filterKey) {
		(filter[filterKey] || []).forEach((subFilter) => {
			const key = subFilter ? Object.keys(subFilter)[0] : null;
			if (!key) return;
			if (options?.customFiltersRoute && findField(options?.customFiltersRoute, key)?.isCustomRoute) {
				customFilters.push(subFilter);
			} else {
				normalFilters.push(subFilter);
			}
		});
	} else {
		// If there's no _and or _or, treat the entire filter object as a single filter condition
		normalFilters = filter;
	}
	// Check if normalFilters is empty or a single filter condition
	const isNormalFiltersEmpty = Array.isArray(normalFilters) && normalFilters.length === 0;
	const outputNormalFilters = isNormalFiltersEmpty
		? undefined
		: filterKey
		? { [filterKey]: normalFilters }
		: normalFilters;

	// Check if customFilters is empty
	const isCustomFiltersEmpty = Object.keys(customFilters).length === 0;
	const outputCustomFilters = isCustomFiltersEmpty
		? undefined
		: filterKey
		? { [filterKey]: customFilters }
		: customFilters;

	return {
		normalFilters: outputNormalFilters,
		customFilters: outputCustomFilters,
	};
};
